import { render, staticRenderFns } from "./NeonatusAssessment.vue?vue&type=template&id=d3656796&scoped=true"
import script from "./NeonatusAssessment.vue?vue&type=script&lang=js"
export * from "./NeonatusAssessment.vue?vue&type=script&lang=js"
import style0 from "./NeonatusAssessment.vue?vue&type=style&index=0&id=d3656796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3656796",
  null
  
)

export default component.exports